function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 11 13.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-768 -530.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 530.37,
    width: 11,
    height: 13.63,
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-fire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M778.92,539c-.36-1.59-2-2.79-3.2-3.87a3,3,0,0,1-1.29-2,4.74,4.74,0,0,1,.88-2.68c-2.82,2.27-5.68,4.7-6.93,8a3.82,3.82,0,0,0,.57,4.24,6,6,0,0,0,2.23,1.37,2.42,2.42,0,0,1-.95-2.4c.23-2.11,1.54-3.9,2.86-5.59a2.72,2.72,0,0,0-.11,1.69,2,2,0,0,0,1.09,1.05,5.68,5.68,0,0,1,2.49,1.89,2.7,2.7,0,0,1-1.28,3.39c2.27-.79,4.14-2.81,3.64-5",
    transform: "translate(-768 -530.37)",
    style: {
      fill: "#d25242"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFire);
export default __webpack_public_path__ + "static/media/icon-fire.e2b888a345ea564d7a9577f5a68d60f0.svg";
export { ForwardRef as ReactComponent };